import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { organizerService } from "../shared/api/organizerService";

interface Props {
	organizerId: Id;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const OrganizerListContextMenu: FC<Props> = ({ organizerId, handleEdit, handleDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(
		() => organizerService.showUsage(organizerId).then((r) => r.data.data),
		[organizerId],
	);

	const canUpdate = useHasPermission<PermissionName>(["organizers.update"]);
	const canDelete = useHasPermission<PermissionName>(["organizers.delete"]);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				{canUpdate && (
					<ContextMenuItem label={t("Edit")} action={handleEdit} title={t("Edit")} icon="edit" shortcut="primary" />
				)}
				{canDelete && (
					<ContextMenuDeleteWithModelUsageItem
						label={t("Delete")}
						title={t("Delete")}
						showUsageAction={showUsageAction}
						modelName={t("Organizer")}
						confirmationBody={t("Are you sure you want to delete this organizer?")}
						deleteAction={handleDelete}
						shortcut="danger"
					/>
				)}
			</ContextMenu>
		</>
	);
};
